import { apiService } from "../axiosService";

export const getPromoterConfig = async ({ signal } = {}) => {
  const data = await apiService.get("/promotor", { signal });
  return data;
};

export const updatePromoterConfig = async (data) => {
  return await apiService.put("/promotor", data);
};

export const getUsersList = async ({ signal, search } = {}) => {
  const params = {};
  if (search) params.search = search;

  return await apiService.get("/users", {
    signal,
    params
  });
};

export const createPromoterInstance = async (payload) => {
  const { data } = await apiService.post("/promotor_instance", payload);
  return data;
};

export const getPromoterInstances = async ({ signal, params } = {}) => {
  const data = await apiService.get("/promotor_instance/all", { signal, params });
  return data;
};

export const createInstanceAction = async (instanceId, data) => {
  return await apiService.post(`/promotor_instance/${instanceId}/action`, data);
};

export const updatePromoterInstance = async (id) => {
  return await apiService.post(`/promotor_instance/${id}/promote`);
};

export const getMetrics = async () => {
  return await apiService.get("/promotor_instance/metrics");
};
